import { useState, useEffect } from "react";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";
import Spinner from "../Helpers/Spinner";

function EditUserForm({ setIsModalOpen, onUserAdded, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isFetching, setIsFetching] = useState(false); // For fetching data

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "", // Optional: leave empty to not change
    role: "User",
  });

  // Fetch user data when the component mounts
  useEffect(() => {
    const fetchUser = async () => {
      setIsFetching(true);
      try {
        const response = await API.get(`/users/${id}`); // Using /:id as per your backend
        const user = response.data;
        setFormData({
          name: `${user.firstName} ${user.lastName}` || "",
          firstName: user.firstName || "",
          lastName: user.lastName || "",
          email: user.email || "",
          password: "", // Don't prefill password for security
          role: user.role || "User",
        });
      } catch (error) {
        setErrorMessage("Failed to fetch user data");
        console.error("Error fetching user:", error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    setIsLoading(true);
    setErrorMessage(""); // Clear previous errors

    // Validation
    if (!formData.role || formData.role === "") {
      setErrorMessage("Please select a role.");
      return;
    }

    try {
      // Prepare update data, only include password if provided
      const updateData = {
        name: `${formData.firstName} ${formData.lastName}`,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        role: formData.role,
      };
      if (formData.password) {
        updateData.password = formData.password; // Send plaintext; backend hashes it
      }

      const response = await API.put(`/users/${id}`, updateData); // Using /:id as per your backend
      console.log("User updated:", response.data);

      // Notify parent component of the update
      onUserAdded(response.data); // Assuming onUserAdded handles updates too
      setIsModalOpen(false); // Close modal on success
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Failed to update user";
      setErrorMessage(errorMsg);
      console.error("Error updating user:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // if (isFetchingUser) return <Spinner />;

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
    //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
    //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
    //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
    //         Edit User
    //       </h2>
    //       <form onSubmit={handleSubmit} className="space-y-6">
    //         <ErrorMessage message={errorMessage} />
    //         {isFetchingUser && (
    //           <p className="text-center text-gray-600">Loading...</p>
    //         )}

    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Name
    //           </label>
    //           <input
    //             type="text"
    //             name="name"
    //             value={formData.name}
    //             onChange={handleChange}
    //             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //             placeholder="Enter user name"
    //             required
    //           />
    //         </div>
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Email
    //           </label>
    //           <input
    //             type="email"
    //             name="email"
    //             value={formData.email}
    //             onChange={handleChange}
    //             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //             placeholder="Enter user email"
    //             required
    //           />
    //         </div>
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Password (leave blank to keep current)
    //           </label>
    //           <input
    //             type="password"
    //             name="password"
    //             value={formData.password}
    //             onChange={handleChange}
    //             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //             placeholder="Enter new password"
    //           />
    //         </div>
    //         <div>
    //           <label className="block text-sm font-medium text-gray-700 mb-1">
    //             Role
    //           </label>
    //           <select
    //             name="role"
    //             value={formData.role}
    //             onChange={handleChange}
    //             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //           >
    //             <option value="user">User</option>
    //             <option value="admin">Admin</option>
    //           </select>
    //         </div>
    //         <div className="flex gap-4">
    //           <button
    //             type="submit"
    //             disabled={isLoading}
    //             className={`w-1/2 bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition duration-200 ${
    //               isLoading ? "opacity-50 cursor-not-allowed" : ""
    //             }`}
    //           >
    //             {isLoading ? "Updating..." : "Update User"}
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => setIsModalOpen(false)}
    //             className="w-1/2 bg-gray-500 text-white py-2 rounded-md hover:bg-gray-600 transition duration-200"
    //           >
    //             Cancel
    //           </button>
    //         </div>
    //       </form>
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
      <div className="w-full p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
        {isFetching && (
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
            <Spinner />
          </div>
        )}
        {/* Header (Static) */}
        <div className="">
          {/* Static Header */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
            Edit User
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto space-y-3">
          <form>
            <div className="p-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName || ""}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                placeholder="Enter first name"
                required
              />
            </div>

            <div className="p-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName || ""}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                placeholder="Enter last name"
                required
              />
            </div>

            <div className="p-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                placeholder="Enter user email"
                required
              />
            </div>

            <div className="p-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                placeholder="Enter password"
                required
              />
            </div>

            <div className="p-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Role
              </label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              >
                <option value="">Select Role</option>
                <option value="User">User</option>
                <option value="Admin">Admin</option>
              </select>
            </div>
          </form>
        </div>

        {/* Action buttons */}
        <div className="flex justify-end gap-3 mt-2 p-2">
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleSubmit()}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              isLoading
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditUserForm;
